'use client';
import { jsx } from 'react/jsx-runtime';
import { useLayoutEffect } from 'react';
import { useModalDialogContext } from './modal-dialog.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let a = parseInt(tokensRaw.SwanBaseBreakpointXsEnd, 10), isSufficientScreenForPinning = ()=>{
    let { innerHeight: e, innerWidth: t } = window;
    return !(t > e && t <= a);
};
const ModalDialogFooter = renderWithRef('ModalDialogFooter', null, (o, n)=>{
    var { children: a, pinned: s = false } = o, l = _object_without_properties(o, [
        "children",
        "pinned"
    ]);
    let { setFooterPinned: p, showDialog: d } = useModalDialogContext();
    return useLayoutEffect(()=>{
        if (!d) return;
        let updateFooterPinnedStatus = ()=>{
            p(!!s && isSufficientScreenForPinning());
        };
        return updateFooterPinnedStatus(), window.addEventListener('resize', updateFooterPinnedStatus), ()=>{
            p(void 0), window.removeEventListener('resize', updateFooterPinnedStatus);
        };
    }, [
        p,
        d,
        s
    ]), jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        props: l,
        classNames: [
            'swan-modal-dialog-footer'
        ],
        children: a
    });
});

export { ModalDialogFooter };
